var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('partnerBranch',{attrs:{"partners":_vm.partners,"subPartners":_vm.subPartners,"partnerBranches":_vm.partnerBranches},on:{"getpartnerBranches":_vm.getpartnerBranches}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }